import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=2686a16a&scoped=true&"
import script from "./FooterContent.vue?vue&type=script&lang=js&"
export * from "./FooterContent.vue?vue&type=script&lang=js&"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=2686a16a&scoped=true&lang=css&"
import style1 from "./FooterContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686a16a",
  null
  
)

export default component.exports